import styled from "styled-components/macro";

export const ErrorPopupWrapper = styled.div<{
  deviceType: string;
  onTop?: boolean;
}>`
  position: ${({ onTop }) => (onTop ? "absolute" : "fixed")};
  ${({ onTop }) =>
    onTop
      ? "left: 20px; top: 20px; width: inherit; right: 20px;"
      : "left: 40px; bottom: 40px; max-width: 480px;"}
  background-color: ${({ theme }) => theme.greyDark};
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  padding: 14px;
  gap: 16px;
  border-radius: 4px;
  justify-content: space-between;
  flex-direction: ${({ deviceType }) =>
    deviceType === "mobile" ? "column" : "row"};
  z-index: 1400;
`;
